import React from 'react';
import { Box, Card, styled } from '@mui/material';
import { useTemplateEditorMode } from '@tymely/features';
import { stopProgagation } from '@tymely/utils';

import TemplateGuidelines from './TemplateGuidelines';
import { VariablesSidebarContent } from './VariablesSidebarContent';
import { useTemplateEditor } from './TemplateEditorProvider';

const _Card = styled(Card)`
    height: 100%;
    padding: ${({ theme }) => theme.spacing(2)};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
`;

const _FormContainer = styled(Box)`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

type TemplateSideBarProps = {
    children?: React.ReactNode;
};

const TemplateSideBar = ({ children }: TemplateSideBarProps) => {
    const { template, onCodeChange } = useTemplateEditor();
    const { editorMode } = useTemplateEditorMode();

    return (
        <_Card onKeyDown={stopProgagation}>
            <_FormContainer>
                {editorMode === 'prompt' && (
                    <TemplateGuidelines template={template || null} onCodeChange={onCodeChange} />
                )}
                <VariablesSidebarContent />
            </_FormContainer>
            {children}
        </_Card>
    );
};

export default TemplateSideBar;
